<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="filterStatuses.length">
				<span class="ml-2">فیلتر وضعیت:</span>
				<v-btn-toggle v-model="statusFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="status in filterStatuses" :key="status" :value="status" small @click="selectedItems = []">
						{{ status }}
						<v-badge color="blue" :content="status === 'همه' ? items.length : items.filter(x => x.str_AgentStatus == status).length || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="12" v-if="loanTypes.length">
				<span class="ml-2">فیلتر نوع وام:</span>
				<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
						{{ loanType.title }}
						<v-badge color="blue" :content="loanType.id === 0 ? items.length : items.filter(x => x.loanModel.id == loanType.id).length || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="8">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="4">
				<div class="d-flex justify-end align-center">
					<export-excel :items="items" :headers="headers" :fileName="'لیست درخواست وام های نماینده'">
					</export-excel>
					<v-btn outlined small color="secondary" fab @click="print" size="small" class="mx-1">
						<v-icon>
							mdi-printer
						</v-icon>
					</v-btn>
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="primary" outlined dark v-bind="attrs" v-on="on">
								تغییر وضعیت گروهی
							</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="status in statuses" :key="status.id" style="cursor: pointer;">
								<v-list-item-title @click="changeAgentStatusBulk(status.id)">به {{ status.title }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="filteredItems" :items-per-page="500" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>
								<v-checkbox color="secondary" v-model="row.item.ch" @change="(val) => updateSelectedItems(val, row.item)" />
							</td>
							<td>
								<div class="info--text" style="cursor:pointer" @click="edit(row.item)">
									<span class="text-small info--grey">شماره درخواست:</span> {{ row.item.code }}
								</div>
								<div class="">
									<small class="text-small info--grey">مبلغ: {{ row.item.amount.toString().toPriceFormat() }}</small>
								</div>
								<div class="">
									<small class="text-small info--grey">تاریخ: &lrm;{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}</small>
								</div>
								<div><small>{{ row.item.loanModel.title }}</small></div>
							</td>
							<td>
								<div>{{ row.item.memberModel.fullName }}</div>
								<div class="grey--text">{{ row.item.memberModel.nationalCode }}</div>
							</td>
							<td class="text-center">
								{{ row.item.str_AgentStatus }}
							</td>
							<td class="text-center">
								<div>{{ row.item.userLoan ? row.item.userLoan.loanModel.title : '' }}</div>
								<div v-if="row.item.userLoan" class="grey--text">شماره وام: {{ row.item.userLoan ? row.item.userLoan.code
									: '' }}</div>
							</td>
							<!-- <td class="text-center">
								{{ row.item.userLoan && row.item.userLoan.agentDueDate_Persian ?
									row.item.userLoan.agentDueDate_Persian.date : '' }}
							</td>
							<td class="text-center">
								<div>{{ row.item.userLoan ? row.item.userLoan.agentPrice.toString().toPriceFormat() : '' }}</div>
							</td>
							<td class="text-center">
								<div class="info--text" style="cursor: pointer;" @click="transactionList(row.item.userLoan)">{{
									row.item.userLoan ? row.item.userLoan.sumSponsorPayments.toString().toPriceFormat() : '' }}</div>
								<div @click="transaction(row.item.userLoan)"><small class="secondary--text" style="cursor: pointer;">ثبت
										واریزی</small></div>
							</td> -->
							<td class="text-right">
								<div v-if="row.item.userLoan">
									<div v-if="agent.agentId">
										<small>نام نماینده: </small>
										<small class="grey--text">{{ row.item.userLoan.agentModel.businessName }}</small>
									</div>
									<div>
										<small>سررسید تسویه: </small>
										<small class="grey--text">{{ row.item.userLoan && row.item.userLoan.agentDueDate_Persian ?
											row.item.userLoan.agentDueDate_Persian.date : '' }}</small>
									</div>
									<div>
										<small>سهم نماینده: </small>
										<small class="grey--text">{{ row.item.userLoan ?
											row.item.userLoan.agentPrice.toString().toPriceFormat() : '' }}</small>
									</div>
									<div>
										<small>مجموع واریز اسپانسر: </small>
										<small class="info--text" style="cursor: pointer;" @click="transactionList(row.item.userLoan)">{{
											row.item.userLoan ? row.item.userLoan.sumSponsorPayments.toString().toPriceFormat() : '' }}</small>
									</div>
									<div class="text-center">
										<v-btn color="secondary" @click="transaction(row.item)" x-small>ثبت واریزی</v-btn>
									</div>
								</div>
								<div class="red--text" v-else>
									<small>
										اطلاعات تسویه پس از تبدیل به وام فعال می شود.
									</small>
								</div>
							</td>
							<td class="text-right" v-if="agent.agentId">
								<div>
									<small>سررسید تسویه: </small>
									<small class="grey--text">{{ row.item.userLoan && row.item.userLoan.subAgentDueDate_Persian ?
										row.item.userLoan.subAgentDueDate_Persian.date : '' }}</small>
								</div>
								<div>
									<small>سهم زیرمجموعه: </small>
									<small class="grey--text">{{ row.item.userLoan ?
										row.item.userLoan.subAgentPrice.toString().toPriceFormat() : ''
										}}</small>
								</div>
								<div>
									<small>مجموع واریز به زیرمجموعه: </small>
									<small class="info--text" style="cursor: pointer;" @click="subAgentTransactionList(row.item.userLoan)">{{
										row.item.userLoan ? row.item.userLoan.sumParentAgentPayments.toString().toPriceFormat() : ''
									}}</small>
									<!-- <div class="text-center">
										<v-btn color="secondary" @click="subAgentTransaction(row.item.userLoan)" x-small>ثبت واریزی</v-btn>
									</div> -->
								</div>
							</td>
							<td class="text-center">
								<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialog" scrollable persistent max-width="1100px">
			<ModifyRequest ref="modifyRequest" v-if="dialog" :data="selectedRequest" @callbck="callbck" @close="dialog = false" />
		</v-dialog>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyTransaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAgentTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogAgentTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<AgentTransactions v-if="dialogAgentTransactionsList" :agent="localAgent" :userLoan="selectedUserLoan" @update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSubAgentTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<SubAgentTransactions v-if="dialogSubAgentTransactionsList" :agent="agent" :userLoan="selectedUserLoan" @update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<div id="printHtml" style="display: none;">
			<h2 style="margin-bottom: 10px;text-align: center;">لیست درخواست های انتخاب شده</h2>
			<table style="direction: rtl;width: 100%;">
				<thead>
					<tr style="border-bottom: 2px solid #ddd;background-color: #ddd;">
						<th style="text-align: center; padding: 5px;font-weight: bold;border-bottom: 2px solid #ccc;">
							نام نماینده</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;border-bottom: 2px solid #ccc;">
							شماره درخواست</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;border-bottom: 2px solid #ccc;">
							نام مشتری</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;border-bottom: 2px solid #ccc;">
							تاریخ ثبت درخواست</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;border-bottom: 2px solid #ccc;">
							مشخصات وام</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;border-bottom: 2px solid #ccc;">
							مبلغ درخواستی</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in selectedItems" :key="item.id" style="border-bottom: 1px solid #ddd">
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;">{{ agent.businessName }}</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;">{{ item.code }}</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;">
							<div>{{ item.memberModel.fullName }}</div>
							<div class="grey--text">کد ملی: {{ item.memberModel.nationalCode }}</div>
						</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;">
							{{ item.requestDate_Persian.date }}
						</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;">
							{{ item.loanModel.title }}
						</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;">
							{{ item.amount.toString().toPriceFormat() }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import { call, get } from 'vuex-pathify'
	import printJS from 'print-js'

	export default {
		name: 'AgentRequests',
		props: {
			agent: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyTransaction: () => import('@/views/admin/ModifyTransaction'),
			ModifyRequest: () => import('@/views/admin/ModifyLoanRequest.vue'),
			AgentTransactions: () => import('./AgentTransactions.vue'),
			SubAgentTransactions: () => import('@/views/agent/sub-agent/SubAgentTransactions.vue'),
		},
		data() {
			return {
				localAgent: null,
				selectedTransaction: null,
				selectedUserLoan: null,
				dialogSubAgentTransactionsList: false,
				dialogAgentTransactionsList: false,
				dialogTransaction: false,
				errorMessages: '',
				search: '',
				loading: false,
				headers: [
					{
						text: '',
						align: 'start',
						sortable: false,
						value: 'code',
						width: 20
					},
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 190
					}, {
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
						width: 125
					},
					{
						text: 'کد ملی',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					},
					{
						text: 'عنوان وام',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center d-none',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'زمان ثبت درخواست',
						align: 'center d-none',
						sortable: true,
						value: 'requestDate_Persian',
					},
					{
						text: 'وضعیت نماینده',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'تبدیل به وام',
						align: 'center',
						sortable: true,
						value: 'userLoan.code',
						width: 150
					},
					{
						text: `${this.agent.agentId ? 'تسویه با نماینده سطح 1' : 'تسویه با نماینده'}`,
						align: 'center',
						sortable: true,
						value: 'userLoan.agentDueDate_Persian',
						width: 220
					},
					{
						text: 'تسویه با نماینده زیرمجموعه',
						align: 'center',
						sortable: true,
						value: 'userLoan.subAgentDueDate_Persian',
						width: 250
					},
					{
						text: 'عملیات',
						align: 'center',
						sortable: false,
						width: 75,
					}
				],
				items: [],
				dialog: false,
				selectedRequest: null,
				filterStatuses: [],
				statusFilter: 'همه',
				selectedItems: [],
				loanTypes: [],
				loanTypeFilter: '',
			}
		},
		mounted() {
			this.localAgent = this.agent
			if (!this.localAgent.agentId) {
				this.headers = this.headers.filter(x => x.value !== 'userLoan.subAgentDueDate_Persian')
			}
			this.loadData()
			this.fetchLoanRequestStatus()
		},
		computed: {
			statuses: get('loanRequestStatus/agentStatuses'),
			filteredItems() {
				if ((!(this.statusFilter || []).length || this.statusFilter === 'همه') && !this.loanTypeFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.statusFilter !== 'همه')
					clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.str_AgentStatus) > -1)

				if (this.loanTypeFilter)
					clonedItems = clonedItems.filter(x => this.loanTypeFilter.indexOf(x.loanModel.id) > -1)

				return clonedItems
			}
		},
		methods: {
			fetchLoanRequestStatus: call('loanRequestStatus/fetch'),
			loadData() {
				this.loading = true
				api.get('admin/userLoanRequest/ListByAgentId/' + this.agent.id, null)
					.then(response => {
						this.items = response

						this.filterStatuses = [...new Set(response.map(x => x.str_AgentStatus))]
						if (this.filterStatuses.length)
							this.filterStatuses.push('همه')

						this.loanTypes = Object.values(
							response.reduce((acc, obj) => ({ ...acc, [obj.loanModel.id]: obj.loanModel }), {})
						)
						if (this.loanTypes.length) {
							this.loanTypes.push({ id: 0, title: 'همه' })
							this.loanTypeFilter = 0
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			edit(item) {
				this.dialog = true
				this.selectedRequest = item
			},
			callbck(result) {
				this.dialog = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
			updateSelectedItems(state, row) {
				if (!row)
					return
				const index = this.selectedItems.findIndex(x => x.id === row.id)
				if (state) {
					if (index === -1)
						this.selectedItems.push(row)
				} else {
					if (index !== -1)
						this.selectedItems.splice(index, 1)
				}
			},
			selectionToggler(state) {
				if (state) {
					this.selectedItems = this.filteredItems.map(x => x)
				} else {
					this.selectedItems = []
				}
			},
			print() {
				printJS({
					printable: 'printHtml',
					type: 'html',
					scanStyles: true, // If true inline styles will be removed
					targetStyles: ['*'],
					style: `
					@font-face {
							font-family: 'Yekan';
							src: url('/iranyekanweb.ttf') format('truetype');
							font-weight: normal;
							font-style: normal;
					}
					#printHtml {
							display: block !important;
							font-family: 'Yekan', sans-serif;
					}
    		`
				})
			},
			transaction(userLoanRequest) {
				if (!userLoanRequest?.userLoan) {
					toast.error('وام مرتبط برای این درخواست هنوز ثبت نشده است، بنابراین امکان ثبت واریزی وجود ندارد.')
					return
				}
				if (userLoanRequest.userLoan.agentModel)
					this.localAgent = userLoanRequest.userLoan.agentModel
				this.selectedTransaction = {
					id: emptyId,
					paymentMethod: 2,
					isWithdraw: true,
					agent: {
						id: this.localAgent.id,
						businessName: this.localAgent.businessName,
						mobile: this.localAgent.mobile,
						firstName: this.localAgent.firstName,
						bankAccountsJson: this.localAgent.bankAccountsJson
					},
					userLoan: {
						id: userLoanRequest.userLoan.id,
						title: `کد: ${userLoanRequest.userLoan.code}, عنوان: ${userLoanRequest.userLoan.loanModel.title}`,
						code: userLoanRequest.userLoan.code
					},
					amount: Math.max(userLoanRequest.userLoan.agentPrice - userLoanRequest.userLoan.sumSponsorPayments, 0),
					maxAmount: userLoanRequest.userLoan.agentPrice - userLoanRequest.userLoan.sumSponsorPayments,
					userLoanRequest: { id: userLoanRequest.id },
					agentStatus: userLoanRequest.agentStatus,
					customerStatus: userLoanRequest.status,
				}
				this.dialogTransaction = true
			},
			callbck_transaction(result) {
				this.dialogTransaction = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
			transactionList(userLoan) {
				if (userLoan.agentModel)
					this.localAgent = userLoan.agentModel
				this.selectedUserLoan = userLoan
				this.dialogAgentTransactionsList = true
			},
			async changeAgentStatusBulk(newStatus) {
				if (this.selectedItems.length === 0) {
					toast.error('هیچ آیتمی انتخاب نشده است، ابتدا آیتم های مورد نظر را انتخاب کنید')
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					`آیا از تغییر وضعیت ${this.selectedItems.length} آیتم مطمئن هستید؟`,
				)) {
					api.post('admin/UserLoanRequest/ChangeAgentStatusBulk/', { ids: this.selectedItems.map(x => x.id), agentStatusId: newStatus })
						.then(
							response => {
								toast.success('تغییر وضعیت با موفقیت انجام شد.')
								this.loadData()
								this.$emit('update')
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			subAgentTransactionList(userLoan) {
				this.selectedUserLoan = userLoan
				this.dialogSubAgentTransactionsList = true
			},
		}
	}
</script>
<style></style>
